import React from 'react';
import { Row } from '../../../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../../../CommonComponents/OPL/Grid/Column';
import { ReviewLabel } from './ReviewRow.styles';
import { BorderProps } from '../../../../../../theme/styledProps';

interface Props extends BorderProps {
  label: string;
}

export const ReviewRow: React.FC<Props> = ({ label, children, ...rest }) => {
  return (
    <Row borderBottom="1px solid" borderColor="neutral.200" {...rest}>
      <Column width={5}>
        <ReviewLabel>{label}</ReviewLabel>
      </Column>

      <Column width={7}>{children}</Column>
    </Row>
  );
};
